<template>
  <div class="myLombard p-24-32">
    <div class="loader" v-if="loader">
      <img src="@/assets/img/loader.gif" alt="" />
    </div>
    <div v-if="message" class="message">{{ message }}</div>
    <div v-else>
      <div v-if="step === 1">
        <div class="menu">
          <ul>
            <li :class="{ active: this.tab === 1 }" @click="clickIndex(1)">
              {{ $t("active") }}
            </li>
            <li :class="{ active: this.tab === 2 }" @click="clickIndex(2)">
              {{ $t("all") }}
            </li>
          </ul>
        </div>
        <div class="loans">
          <div
            class="loans-not"
            v-if="
              filterTickets != null &&
                filterTickets != 'underfined' &&
                filterTickets.length < 1
            "
          >
            {{ $t("text_13") }}
          </div>
          <div
            class="loan clearfix"
            v-else
            v-for="(ticket, index) in filterTickets"
            :key="index"
          >
            <div class="flex">
              <div class="box">
                <div class="title-l">
                  {{ $t("ticket_number_2") }} {{ ticket.code }}
                </div>
                <p>
                  <span>{{ $t("status") }}</span>
                  <span>{{ ticket.status }}</span>
                </p>
                <p>
                  <span>{{ $t("maturity_date") }}</span>
                  <span>{{
                    moment(ticket.prolongDate).format("DD.MM.YYYY")
                  }}</span>
                </p>
                <p>
                  <span>{{ $t("credit_amount") }}</span>
                  <span>{{ ticket.sumKr }} тг</span>
                </p>
              </div>
              <div class="status red" v-if="ticket.status === 'Просрочен'">
                {{ ticket.status }}
              </div>
              <div class="status yellow" v-else>
                <span>{{ ticket.days }}</span>
                <span class="small">{{ $t("days") }}</span>
              </div>
            </div>
            <button
              class="button-yellow"
              v-if="ticket.sumKr !== 0"
              @click="
                show(ticket);
                feeTicket(ticket);
              "
            >
              {{ $t("extend") }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="step === 2" class="page-2">
        <div class="back" @click="clickIndex(3)">
          <img src="@/assets/img/icon/back.svg" alt="" />{{ $t("back") }}
        </div>
        <div class="loans">
          <div class="loan clearfix">
            <div class="flex">
              <div class="box">
                <div class="title-l">
                  {{ $t("ticket_number_2") }} <span>{{ ticketPage.code }}</span>
                </div>
                <p>
                  <span>{{ $t("status") }}</span>
                  <span>{{ ticketPage.status }}</span>
                </p>
                <p>
                  <span>{{ $t("maturity_date") }}</span>
                  <span>{{
                    moment(ticketPage.prolongDate).format("DD.MM.YYYY")
                  }}</span>
                </p>
                <p>
                  <span>{{ $t("credit_amount") }}</span>
                  <span>{{ ticketPage.sumKr }} тг</span>
                </p>
                <p v-if="fee_data != ''">
                  <span>{{ $t("amount_fine") }}</span>
                  <span> {{ fee }} тг</span>
                </p>
                <p>
                  <span>{{ $t("rollover_amount") }}</span>
                  <span>{{ per_day * days }} тг</span>
                </p>
              </div>
              <div class="status red" v-if="ticketPage.status === 'Просрочен'">
                {{ ticketPage.status }}
              </div>
              <div class="status yellow" v-else>
                <span>{{ ticketPage.days }}</span>
                <span class="small">{{ $t("days") }}</span>
              </div>
            </div>
            <div class="item">
              <div class="item-click" @click="clickIndex(4)">
                <span>{{ $t("mortgaged_property") }}</span>
                <img src="@/assets/img/icon/down.svg" alt="" />
              </div>
              <div class="item-content" v-if="showloan">
                <div class="title-i">{{ $t("prolongation") }}</div>
                <div class="fm-graf">
                  <div class="fmg">
                    <span>{{ $t("parameters") }}</span>
                    <span class="small"
                      >{{ $t("minimum") }} {{ $t("day_d") }}
                      {{ ticketPage.min_days }}
                    </span>
                  </div>
                  <div class="fm-border">
                    <vue-slider
                      v-model="days"
                      :min="ticketPage.min_days"
                      :max="max"
                      :tooltip="'always'"
                      @change="dayFunc(ticketPage)"
                    />
                    <div class="numbers">
                      <span>{{ ticketPage.min_days }}</span>
                      <span>{{ max }}</span>
                    </div>
                    <div class="border"></div>
                  </div>
                </div>
                <div class="fm-calc">
                  <div class="fmc">
                    <span>{{ $t("days_extension") }}</span>
                    <input
                      type="number"
                      class="number"
                      pattern=" 0+\.[0-9]*[1-9][0-9]*$"
                      :min="ticketPage.min_days"
                      :max="max"
                      v-model="days"
                      @change="
                        defaultValue(ticketPage);
                        dayFunc(ticketPage);
                      "
                      @input="dayFunc(ticketPage)"
                      @keyUp="dayFunc(ticketPage)"
                      name="input-vue-slider"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    />
                  </div>
                  <!-- <div class="fmc">
                    <span>{{$t('use_SLT')}}</span>
                    <div class="switch" @click="toggleSwitch($event)">
                      <switches
                        v-model="switchLoan"
                        type-bold="true"
                      ></switches>
                    </div>
                  </div>
                  <div class="calc" v-if="paySlt">
                    <div class="clc">
                      <p>{{ pay }}</p>
                      <span>{{$t('to_pay')}}</span>
                    </div>
                    <div class="plus">+</div>
                    <div class="clc">
                      <p class="bg">{{ slt }}</p>
                      <span>SLT</span>
                    </div>
                  </div> -->
                  <div class="fmc">
                    <span>{{ $t("amount_payment") }}</span>
                    <p>{{ pay_all }} тг</p>
                  </div>
                  <div class="fmc" v-if="vendorComission">
                    <span>{{ $t("vendor_comission") }}</span>
                    <span>{{ vendorComission }} тг</span>
                  </div>
                </div>
                <!-- Функционал привязки карты -->
<!--                <div class="dropdown">-->
<!--                  <button-->
<!--                    class="dropdown-toggle"-->
<!--                    type="button"-->
<!--                    data-toggle="dropdown"-->
<!--                  >-->
<!--                    <img src="@/assets/img/icon/card.svg" alt="" class="card" />-->
<!--                    <span class="number" v-if="selected_card">{{ selected_card.cardMask }}</span>-->
<!--                    <span class="caret1">-->
<!--                      <img src="@/assets/img/icon/down.svg" alt=""/>-->
<!--                    </span>-->
<!--                  </button>-->
<!--                  <ul class="dropdown-menu" :class="{ disabled: disabled }">-->
<!--                    <li-->
<!--                      v-for="(card, index) in cardList"-->
<!--                      @click="changeActiveCard(card)"-->
<!--                      :key="index"-->
<!--                    >-->
<!--                      <div>-->
<!--                        <button class="delete" @click="deleteCard(card.cardId)">-->
<!--                          <img src="@/assets/img/icon/delete.svg" alt="" />-->
<!--                        </button>-->
<!--                        <img-->
<!--                          src="@/assets/img/icon/card.svg"-->
<!--                          alt=""-->
<!--                          class="card"-->
<!--                        />-->
<!--                      </div>-->
<!--                      <span class="number">{{ card.cardMask }}</span>-->
<!--                      <span class="selection">-->
<!--                        <img-->
<!--                          src="@/assets/img/icon/done.svg"-->
<!--                          alt=""-->
<!--                          v-if="card.cardMask === selected_card.cardMask || null"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </li>-->
<!--                    <li class="drug" @click="addCard">-->
<!--                      <span>{{ $t("add_card") }}</span>-->
<!--                      <img src="@/assets/img/icon/nextCard.png" alt="" />-->
<!--                    </li>-->
<!--&lt;!&ndash;                    <li&ndash;&gt;-->
<!--&lt;!&ndash;                      class="drug"&ndash;&gt;-->
<!--&lt;!&ndash;                      @click="payProlongationExpress(ticketPage)"&ndash;&gt;-->
<!--&lt;!&ndash;                    >&ndash;&gt;-->
<!--&lt;!&ndash;                      <span>{{ $t("another_card") }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                      <img src="@/assets/img/icon/nextCard.png" alt="" />&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--                  </ul>-->
<!--                </div>-->
                <button
                  class="button-yellow"
                  :class="{ loader_button: loader_button, disabled: disabled }"
                  @click="payTicket(ticketPage)"
                >
                  <img
                    src="@/assets/img/loader.gif"
                    alt=""
                    v-if="loader_button"
                  />
                  <span v-else>{{ $t("pay") }}</span>
                </button>
<!--                <button-->

<!--                  class="button-yellow"-->
<!--                  :class="{ disabled: disabled }"-->
<!--                  @click="payProlongationExpress(ticketPage)"-->
<!--                >-->
<!--                  {{ $t("pay") }}-->
<!--                </button>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-done">
      <div id="modal-success" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                data-dismiss="modal"
                aria-hidden="true"
                class="close"
              >
                <img src="@/assets/img/icon/close.svg" alt="" />
              </button>
              <div class="title-m">
                <img src="@/assets/img/icon/done2.svg" alt="" />{{
                  $t("payment_successful")
                }}
              </div>
              <img src="@/assets/img/1.png" alt="" class="img" />
              <button
                type="button"
                data-dismiss="modal"
                aria-hidden="true"
                class="button-yellow"
                @click="clickIndex(3)"
              >
                ОК
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-done">
      <div id="modal-fail" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                data-dismiss="modal"
                aria-hidden="true"
                class="close"
              >
                <img src="@/assets/img/icon/close.svg" alt="" />
              </button>
              <div class="title-m">
                <img src="@/assets/img/icon/fail.svg" alt="" />{{
                  $t("payment_failed")
                }}
              </div>
              <img src="@/assets/img/4.png" alt="" class="img" />
              <button
                type="button"
                data-dismiss="modal"
                aria-hidden="true"
                class="button-yellow"
                @click="clickIndex(3)"
              >
                ОК
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import Switches from 'vue-switches'
export default {
  name: 'myLombard',
  components: {
    VueSlider,
    Switches
  },
  data () {
    return {
      step: 1,
      tab: 1,
      count_days: 10,
      days: 30,
      max: 30,
      switchLoan: false,
      tickets: [],
      filterTickets: [],
      status: 'Выкуплен',
      loader: false,
      ticketPage: '',
      message: '',
      pay: '',
      paySlt: false,
      slt: 0,
      pay_all: 0,
      showloan: true,
      cardList: '',
      profile: '',
      selected_card: null,
      fee: '',
      fee_data: '',
      loader_button: false,
      disabled: false,
      per_day: 0,
      pay_comission: 0
    }
  },
  created () {
    Promise.all([
      // this.getListCards(),
      this.localData()
    ])
    this.profile = JSON.parse(localStorage.getItem('user'))
  },
  computed: {
    vendorComission () {
      if (!this.pay_comission) return 0

      const comission = (this.pay_all * this.pay_comission) / 100
      const round = Math.round((comission + Number.EPSILON) * 100) / 100

      return round
    }
  },
  methods: {
    async localData () {
      if (localStorage.getItem('tickets') != null) {
        localStorage.removeItem('tickets')
      }
      if (localStorage.getItem('tickets')) {
        this.loader = false
        this.tickets = JSON.parse(localStorage.getItem('tickets'))
        this.filterTickets = this.tickets
        this.filterTickets = this.filterTickets.filter(item => {
          return !this.status.includes(item.status)
        })
        if (localStorage.getItem('message')) {
          this.message = JSON.parse(localStorage.getItem('message'))
        }
      } else {
        await this.getTickets()
      }
    },
    clickIndex (index) {
      if (index === 1) {
        this.tab = 1
        this.filterTickets = this.activeTickets()
      }
      if (index === 2) {
        this.tab = 2
        this.filterTickets = this.tickets
      }
      if (index === 3) {
        this.step = 1
        this.fee = ''
        this.fee_data = ''
      }
      if (index === 4) {
        this.showloan = !this.showloan
      }
    },
    async getTickets () {
      this.loader = true
      const response = await this.$axios.get('/user/gettickets')
      this.loader = false

      let $response = response.data
      if ($response.code === 0 || !$response.data) {
        return
      }

      this.message = $response.message
      if (this.message) {
        localStorage.setItem('message', JSON.stringify(this.message))
      }
      this.tickets = $response.data
      localStorage.setItem('tickets', JSON.stringify(this.tickets))
      this.filterTickets = this.tickets
      this.filterTickets = this.filterTickets.filter(item => !this.status.includes(item.status))
    },
    activeTickets: function () {
      let app = this
      return app.filterTickets.filter(item => {
        return !app.status.includes(item.status)
      })
    },
    show (ticket) {
      this.step = 2
      this.ticketPage = ticket
      this.checkProlong(ticket)
    },
    feeTicket (ticket) {
      this.loader = true
      this.$axios
        .get(
          `${this.$baseDomain}/user/default/check-prolong?id=${ticket.id}&days=30`
        )
        .then(response => {
          const $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.loader = false
          } else {
            this.loader = false
            this.fee_data = $response.data
            this.fee = $response.data.fee
            this.per_day = $response.data.per_day
            this.pay = this.per_day * this.days + this.fee
            this.pay_all = this.pay
            this.pay_comission = $response.data.comission
          }
        })
        .catch(e => console.log(e))
    },
    dayFunc (ticket) {
      if (this.days > this.max) {
        this.days = this.max
      }
      if (this.days >= ticket.min_days) {
        this.checkProlong(ticket)
        const tempTicket = this.ticketPage
        this.ticketPage = []
        this.ticketPage = tempTicket
      }
    },
    checkProlong (ticket) {
      this.a = ticket
      this.pay = this.per_day * this.days + this.fee
      this.pay_all = this.pay
      // this.disabled = true
      // this.$axios
      //   .get(
      //     `${this.$baseDomain}/user/default/check-prolong-v2?id=` +
      //       ticket.id +
      //       "&days=" +
      //       this.days
      //   )
      //   .then(response => {
      //     let $response = response.data;
      //     if ($response.code === 0) {
      //       console.log($response);
      //       this.disabled = false
      //     } else {
      //       this.pay = $response.data.summa;
      //       this.pay_all = this.pay;
      //       this.disabled = false
      //       // if (this.switchLoan == true && this.paySlt == true) {
      //       //   this.pay_all = this.pay - this.slt;
      //       // } else {
      //       //   this.pay_all = this.pay;
      //       // }
      //     }
      //   })
      //   .catch(e => console.log(e));
    },
    /**
     * Получение списка прикрепленных карт
     * @returns {Promise<void>}
     */
    async getListCards () {
      const response = await this.$axios.get('/user/card-list')
      let $response = response.data || { code: 0 }
      if ($response.code === 0) {
        console.log($response)
      } else {
        this.cardList = $response.data
        this.selected_card = $response.data[0]
      }
    },
    defaultValue (ticket) {
      if (this.days.length == 0) {
        this.days = ticket.min_days
      }
      if (this.days < ticket.min_days) {
        this.days = ticket.min_days
      }
      if (this.days > this.max) {
        this.days = this.max
      }
    },
    toggleSwitch (event) {
      this.slt = this.profile.bonus
      if (this.pay > this.slt) {
        this.switchLoan = !this.switchLoan
        this.paySlt = !this.paySlt
      } else {
        this.switchLoan = false
        this.paySlt = false
        event.preventDefault()
      }
      if (this.switchLoan == true && this.paySlt == true) {
        this.pay_all = this.pay - this.slt
      } else {
        this.pay_all = this.pay
      }
    },
    /**
     * Селектор выбора другой карты
     * @param { Object } card объект выбранной карты
     */
    changeActiveCard (card) {
      this.selected_card = card
    },
    /** Регистрируем новую карту */
    addCard () {
      window.open(
        `${this.$baseDomain}/pay/pay-save-card?user_id=${this.profile.id}`
      )
    },
    /**
     * Удаляем карту
     * @param { Number } id Идентификатор карты, что нужно удалить
     */
    deleteCard (id) {
      this.$axios.post('/user/delete-card', { card_id: id })
      this.cardList.filter((i) => i.cardId !== id)
    },
    /**
     * Перекидываем чела на страницу оплаты без привязки карты
     * @param { Object } ticket объект займа, что нужно пролонгировать
     * @param { number } ticket.id идентификатор займа, что нужно пролонгировать
     */
    payWithoutCard ({ id }) {
      if (this.switchLoan === false && this.paySlt === false) {
        this.slt = 0
      }
      window.open(
        `${this.$baseDomain}/pay/pay-prolong?id=${id}&days=${this.days}&bonus=${this.slt}`
      )
    },
    /**
     * Оплата привязанной картой
     * @param { Object } ticket объект займа, что нужно пролонгировать
     * @param { number } ticket.id идентификатор займа, что нужно пролонгировать
     */
    async payWithCard ({ id }) {
      const response = await this.$axios.post(
        '/user/pay-card',
        {
          ticket_id: id,
          days: this.days,
          card_id: this.selected_card.cardId,
          summa: this.pay,
          bonus: this.slt
        }
      )
      let $response = response.data || { error: true }
      if ($response.errors == null) {
        $('.modal-done').appendTo('body')
        $('#modal-success').modal('show')
        this.loader_button = false
      } else {
        $('.modal-done').appendTo('body')
        $('#modal-fail').modal('show')
      }
    },
    /**
     * Событие при клике на кнопку оплатить
     * @param { Object } ticketData объект займа, что нужно пролонгировать
     */
    async payTicket (ticketData) {
      this.loader_button = true
      if (!this.selected_card) {
        this.payWithoutCard(ticketData)
        return
      }
      await this.payWithCard(ticketData)
      this.loader_button = false
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/cabinet/myLombard.vue